import * as React from "react";
import classnames from "classnames";

interface Props
{
    title: string;
    value: string;

    className?: string;
}

export class SearchTextField extends React.Component<Props>
{
    private inputRef: HTMLInputElement;
    
    render() 
    {
        const { title, value, className } = this.props;
        return (
            <div className={classnames('form-group', className)}>
                <label>{title}</label>
                <input type="text" className='form-control' ref={e => this.inputRef=e} value={value} onChange={e => {/*This event will bubble*/}} />
            </div>
        );
    }

    getValue ()
    {
        return this.inputRef.value;
    }
}


// WEBPACK FOOTER //
// ./src/app/components/Pages/Search/SearchTextField.tsx